<template>
  <div>
    <div class="report-area" v-if="content.cosAnimal">
      <!-- <p class="report-title"></p> -->
      <p class="type-name">性格:{{content.cosAnimal.mbtiFeature.type}}&nbsp;{{content.cosAnimal.mbtiFeature.role}}</p>
      <img class="report-img" :src="content.cosAnimal.mbtiImage2" />
    </div>
    <div class="report-area" v-if="content.cosAnimal">
      <p class="type-name">表现</p>
      <p v-html="replaceText(content.cosAnimal.mbtiFeature.behaviorStyle)"></p>
    </div>
    <div class="report-area" v-if="content.cosAnimal">
      <p class="type-name">主要特征</p>
      <p v-html="replaceText(content.cosAnimal.mbtiFeature.mainFeature)"></p>
    </div>
    <div class="report-area" v-if="content.cosHolland">
      <p class="type-name" v-html="'兴趣：'+content.cosHolland.firstType+content.cosHolland.secondType+content.cosHolland.thirdType+' '+content.cosHolland.typeName"></p>
      <p>个人职业兴趣特性与职业之间应有一种内在的对应关系。根据兴趣的不同，人格可分为研究型（I）、艺术型（A）、社会型（S）、企业型（E）、传统型（C）、现实型（R）六个维度，每个人的性格都是这六个维度的不同程度组合。</p>
      <img class="report-img holland-img" :src="hollandFirstTypeImgSrc"/>
      <img class="report-img holland-img" :src="hollandSecondTypeImgSrc"/>
      <img class="report-img holland-img" :src="hollandThirdTypeImgSrc"/>
    </div>
    <div class="report-area" v-if="content.cosValue">
      <p class="type-name" v-html="'价值观:'+content.cosValue.highestValue"></p>
      <p>影响我们做决策的因素有很多，其中就有一个是价值观。所谓价值观，也就是我们最看重的、内心真正追求的东西！</p>
      <p v-html="content.cosValue.highestValueDesc1"></p>
      <p>{{content.cosValue.highestValue}}的你在选择未来职业时，选择的是：</p>
      <img class="report-img score-img" :src=content.cosValue.balanceImage />
    </div>
  </div>
</template>

<script>
export default {
  props:{
    content:Object
  },
  computed: {
		hollandFirstTypeImgSrc() {
		  return 'http://sys.rennengda.com/public/images/holland/' + this.content.cosHolland.firstType+ '.png'
		},
		hollandSecondTypeImgSrc() {
		  return 'http://sys.rennengda.com/public/images/holland/' + this.content.cosHolland.secondType+ '.png'
		},
		hollandThirdTypeImgSrc() {
		  return 'http://sys.rennengda.com/public/images/holland/' + this.content.cosHolland.thirdType+ '.png'
		},
  },
  methods:{
    // 对文本进行处理,换行
    replaceText(txt){
      if(txt){
        const new_txt = txt.replace(/\n/g,'</br>');
        return new_txt;
      }
    },
  }
}
</script>

<style lang="stylus" scoped>

</style>
